<h1 mat-dialog-title>
    Update Records
</h1>
<mat-dialog-content class="addRemoveDialog">
    <div>
        <div>{{message}}</div>
        <div *ngIf="showProgress">
            <mat-progress-bar [mode]="progressMode" mode="determinate" value="{{completeProgress}}"></mat-progress-bar>
            Updating {{currentProcessIndex + 1}} of {{totalProcessCount}}
            <br/> {{processingRecord}}
        </div>
        <div *ngIf="showProfSlider">
            <mat-label>Proficiency- {{proficiency}}</mat-label>
            <mat-slider min="1" max="20" step="1" style="width: 90%;">
                <input matSliderThumb [(value)]="proficiency" >
            </mat-slider>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button  mat-button class="mat-raised-button mat-secondary" (click)="onDismiss()">Cancel</button>
    <button  mat-button class="mat-raised-button mat-primary" (click)="onConfirm()">Process</button>
</mat-dialog-actions>
